import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _OutputAuthorizationItem } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { CardTaps } from "../../../theme/Component/CardTaps";

interface Props {
    _OutputAutorization: any;
}

export const OutputAuthorizationItem = ({ _OutputAutorization }: Props) => {

    const { instance, bean, setBean } = useDataBean(_OutputAuthorizationItem);

    const pagProduct = usePaginator();
    const pagFixed = usePaginator();

    const [listaProduct, setListaProduct] = useState<any[]>([]);
    const [listaFixed, setListaFixed] = useState<any[]>([]);

    useEffect(() => {
        if (_OutputAutorization?.IDOutputAuthorizationRequest) {
            getListaProduct();
        }
    }, [_OutputAutorization, pagProduct.page]);

    useEffect(() => {
        if (_OutputAutorization?.IDOutputAuthorizationRequest) {
            getListaFixed();
        }
    }, [_OutputAutorization, pagFixed.page]);

    const getListaProduct = () => {
        const props = {
            IDOutputAuthorizationRequest: _OutputAutorization.IDOutputAuthorizationRequest,
            ItemType: 101
        };

        instance.getOutputAuthorizationItemRender(pagProduct.page, 15, props)
            .then((resp) => {
                pagProduct.setPages(resp.NumberOfPages);
                pagProduct.setRecords(resp.NumberOfPages * 15);
                pagProduct.setRegiPerPage(15)

                setListaProduct(resp.List)
            })
            .catch(() => toast.error("No se pudieron cargar los Productos"));
    };

    const getListaFixed = () => {
        const props = {
            IDOutputAuthorizationRequest: _OutputAutorization.IDOutputAuthorizationRequest,
            ItemType: 100
        };

        instance.getOutputAuthorizationItemRender(pagFixed.page, 15, props)
            .then((resp) => {
                pagFixed.setPages(resp.NumberOfPages);
                pagFixed.setRecords(resp.NumberOfPages * 15);
                pagFixed.setRegiPerPage(15)

                setListaFixed(resp.List)
            })
            .catch(() => toast.error("No se pudieron cargar los Activos"));
    };

    const headFixed = [
        { title: 'ID', property: 'IDOutputAuthorizationItem', visible: true },
        { title: 'Placa', property: 'FixedAssetItemTicketCode', visible: true },
        { title: 'Activo Fijo', property: 'DescriptionFixed', visible: true },
    ];

    const headProduct = [
        { title: 'ID', property: 'IDOutputAuthorizationItem', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Cantidad', property: 'QuantityProduct', visible: true },
    ];

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Productos', disable: false },
        { id: 1, name: 'Activos Fijos', disable: false },
    ];

    return (
        <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
            <div className="row">
                {indexTap === 0 &&
                    <div className="col-md-12">
                        <BasicTable
                            rowSet={setBean}
                            body={listaProduct}
                            head={headProduct}
                        />
                    </div>
                }
                {indexTap === 1 &&
                    <div className="col-md-12">
                        <BasicTable
                            rowSet={setBean}
                            body={listaFixed}
                            head={headFixed}
                        />
                    </div>
                }
            </div>
        </CardTaps>
    )
}